import React from 'react';

import { IMatchFormationData } from '../../../typings/match-formations';
import { makeClassNames } from '../../../utils/styles';
import Text from '../../atoms/text/text';

import { getGoals, getPlayerInOut, getScoresCard, getTopPlayer } from './match-formation-player-utils';

import './match-formation-player.scss';

export interface IMatchFormationPlayer extends IMatchFormationData {
  fullname?: string | null; // Just like IReferee interface in src/typings/player.ts
  jerseyNum?: number | null;
  playerPageLink?: string | null;
  id: string | number | null;
}

const getJerseyNum = (jerseyNum: number | null | undefined) =>
  typeof jerseyNum === 'number' && jerseyNum > 0 ? jerseyNum : '-';

const classNames = () =>
  makeClassNames({
    MatchFormationPlayer: 'match-formation-player',
    playerJerseyNum: 'match-formation-player--jerseyNum',
    playerName: 'match-formation-player--name',
    iconsWrapper: 'match-formation-player--icons-wrapper',
  });

const MatchFormationPlayer = ({
  jerseyNum,
  /* istanbul ignore next: default value */ fullname = '',
  id,
  topPlayerId,
  substitution,
  scorersCards,
  goals,
  playerPageLink,
}: IMatchFormationPlayer) => {
  const cn = classNames();

  return (
    <div className={cn.MatchFormationPlayer}>
      <Text className={cn.playerJerseyNum} color="blue" fontSize="16--14" fontWeight="500">
        {getJerseyNum(jerseyNum)}
      </Text>
      <Text
        className={cn.playerName}
        color="blue"
        fontSize="14"
        fontWeight="500"
        tag={playerPageLink ? 'a' : 'span'}
        href={playerPageLink ?? undefined}
      >
        {fullname}
      </Text>
      <span className={cn.iconsWrapper}>
        {/* Top Player */}
        {topPlayerId && getTopPlayer(id, topPlayerId)}
        {/* Substitutions: time + icon */}
        {substitution && getPlayerInOut(id, substitution)}
        {/* ScorersCards */}
        {scorersCards && getScoresCard(id, scorersCards)}
        {/* Goals/Penalties/Autogoals */}
        {goals && getGoals(id, goals)}
      </span>
    </div>
  );
};

export default MatchFormationPlayer;
